import React, { useEffect, Suspense } from "react";
import Content from "../../components/Landing/Content";
const GenreCard = React.lazy(() => import("../../components/Landing/GenreCard"));
const Playlists = React.lazy(() => import("../../components/Landing/Playlist"));
const Mobile = React.lazy(() => import("../../components/Landing/Mobile"));
const ReviewSlider = React.lazy(() => import("../../components/Landing/ReviewSlider"));
const Footer = React.lazy(() => import("../../components/Landing/Footer"));
const PricingPlans = React.lazy(() => import("../../components/Landing/PricingPlans"));
const FeatureShowcase = React.lazy(() => import("../../components/Landing/FeatureShowcase"));
const NewsletterSection = React.lazy(() => import("../../components/Landing/NewsletterSection"));
const QuestionAnswer = React.lazy(() => import("../../components/Landing/QuestionAnswer"));
const FeaturedRemixers = React.lazy(() => import("../../components/Landing/FeaturedRemixers"));
const Discovery = React.lazy(() => import("../../components/Landing/Discovery"));

export default function LandingPage() {

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
      <div className="w-full min-h-screen overflow-hidden bg-[#000000] relative">
        {/* Full background container (stars, blur) */}
        <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none flex items-center justify-center">

        </div>

        {/* Actual Page Content on top */}
        <div className="  z-10">
          <Content />

          <Suspense fallback={<div>Loading...</div>}>
          <div className=" mx-auto px-0 ">
            <FeatureShowcase />
            {/* <Supreme /> */}
            {/* <Card /> */}
            {/* <Question /> */}
            <QuestionAnswer />
            <GenreCard />
            <Discovery/>
            <PricingPlans onSelect={(plan) => console.log(plan)} />

            <Playlists />
            <Mobile />
            <FeaturedRemixers />
            <ReviewSlider />
            <NewsletterSection />
          </div>

          <Footer />
          </Suspense>
        </div>
      </div>
  );
}
